import styles from "./drawer.module.scss";
import clsx from "clsx";
import type React from "react";
import { useEffect, useState } from "react";
import BackDrop from "../BackDrop";

export interface DrawerProps {
  open: boolean;
  onclose?: () => void;
  className?: string;
  children?: React.ReactNode | React.ReactNode[];
  fullScreen?: boolean;
}

const Drawer = (props: DrawerProps) => {
  const { open, onclose, className, children, fullScreen = false } = props;
  const [openlazy, setOpenLazy] = useState(open);

  const handleClose = () => {
    setOpenLazy(false);
    onclose && onclose();
  };

  useEffect(() => {
    setOpenLazy(open);
  }, [open]);

  return (
    <BackDrop open={openlazy} onClick={handleClose}>
      <div
        className={clsx(
          styles["drawer"],
          fullScreen && styles["drawer--fullScreen"],
          className,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </BackDrop>
  );
};

export default Drawer;
